var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCandidateAvatarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "#B2C8D8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C30.6281 24 36 18.6281 36 12C36 5.37188 30.6281 0 24 0C17.3719 0 12 5.37188 12 12C12 18.6281 17.3719 24 24 24ZM32.9812 27.0563L28.5 45L25.5 32.25L28.5 27H19.5L22.5 32.25L19.5 45L15.0187 27.0563C8.33437 27.375 3 32.8406 3 39.6V43.5C3 45.9844 5.01562 48 7.5 48H40.5C42.9844 48 45 45.9844 45 43.5V39.6C45 32.8406 39.6656 27.375 32.9812 27.0563V27.0563Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateAvatarIcon);
export default __webpack_public_path__ + "static/media/candidate-avatar-icon.6910b022.svg";
export { ForwardRef as ReactComponent };